export function iconSizeClasses(size) {
  return {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
    xl: 'h-10 w-10',
    '2xl': 'h-12 w-12',
  }[size]
}

export function buttonSizeToIconSizeMap(buttonSize) {
  return {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'md',
    xl: 'md',
  }[buttonSize]
}
